import React, { useRef } from 'react';
import {
    QuickOrderHeaderContainer,
    Heading,
    AutoCompleteContainer,
    AutoCompleteContainerEquity,
    HeadingEquity,
} from '../QuickOrderCommon.styled';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import SearchDropdown from 'src/common/refactoredComponents/searchDropdown/SearchDropdown';
/**
 * Common header for quick order/product list with search/autocomplete.
 * @param {Object} props
 * @param {boolean} props.isCondensedView
 * @param {function} props.t - Translation function
 * @param {function} props.translation - Equity translation function
 * @param {boolean} props.isEquity - If true, render equity-specific UI
 * @param {function} props.setShowBulkAdd
 * @param {string} props.selectedProduct
 * @param {Array} props.productsList
 * @param {function} props.handleOnOpen
 * @param {boolean} props.open
 * @param {boolean} props.loading
 * @param {object} props.AutocompleteStyles
 * @param {function} props.productsListTemplate
 * @param {function} props.updateSelectedProduct
 * @param {function} props.autoCompleteInputChange
 * @param {object} props.AutoCompleteInputFieldStyle
 * @param {string} props.SearchGrayInactive
 * @param {function} props.handlekeyPress
 * @param {function} props.cancelSearchRequest
 * @param {string} [props.titleLabel] - Optional custom title label
 * @param {string} [props.bulkAddLabel] - Optional custom bulk add label
 * @param {Array} [props.products] - Required if isEquity
 * @param {function} [props.getPriceForItems] - Required if isEquity
 * @param {function} [props.setIsCheckPrice] - Required if isEquity
 * @param {function} [props.setIsCheckPriceClicked] - Required if isEquity
 */

const QuickOrderHeader = ({
    isCondensedView,
    t,
    translation,
    isEquity,
    setShowBulkAdd,
    selectedProduct,
    productsList,
    handleOnOpen,
    open,
    loading,
    AutocompleteStyles,
    productsListTemplate,
    updateSelectedProduct,
    autoCompleteInputChange,
    AutoCompleteInputFieldStyle,
    SearchGrayInactive,
    handlekeyPress,
    cancelSearchRequest,
    titleLabel,
    bulkAddLabel,
    setOpen,
    // Equity-specific props
    products = [],
    getPriceForItems,
    setIsCheckPrice,
    setIsCheckPriceClicked,
    quickOrderSearch,
    setQuickOrderSearch,
    id,
    isTemplate,
    isSurgery,
    isSurgeryTemplate,
    isConsignmentAdd,
    cartProducts
}) => {
    const Container = isEquity
        ? AutoCompleteContainerEquity
        : AutoCompleteContainer;
    const HeadingBulk = isEquity ? HeadingEquity : Heading;
    const quickOrderRef=useRef(null);

    const onClose = (_, reason) => {
        if (reason === 'select-option') {
            return;
        }
        setOpen(false);
        cancelSearchRequest(); 
    }

    return (
        <QuickOrderHeaderContainer isSurgeryTemplate={isSurgeryTemplate} isSurgery={isSurgery} isEquity={isEquity} isConsignmentAdd={isConsignmentAdd}>
            <Heading
                letterSpacing={'true'}
                marginLeft={isEquity ? '0px' : undefined} //
            >
                {!isCondensedView ? (
                    <>
                        {isEquity
                            ? translation(
                                  'equity.quickOrder.header.description'
                              )
                            : titleLabel ||
                              t(
                                  'scheduleSurgery.quickOrder.addProductToQuickOrderList'
                              )}
                    </>
                ) : (
                    <>
                        {isEquity
                            ? translation('common.addProductToBulkList')
                            : bulkAddLabel || t('common.addProductToBulkList')}
                    </>
                )}
            </Heading>

            {isEquity && !isTemplate ? (
                <div
                    style={{ display: 'flex' }}
                    className="bulkAddAndCheckPriceBtn" //check this class
                >
                    <HeadingBulk
                        cursor={'pointer'}
                        changeColor //check this
                        marginRight={'0'}
                        marginLeft={'20px'}
                        marginLeftSmal={'-20px'}
                        marginLeftMob={'27px !important'}
                        id = 'quick-order-bulk-add'
                        onClick={() => setShowBulkAdd(true)}
                    >
                        <div style={{ whiteSpace: 'nowrap' }}>
                            {translation('equity.quickOrder.header.bulkAdd')}
                        </div>
                    </HeadingBulk>
                    <HeadingBulk margintopMob={'10px'}>
                        <Button
                            id={'common-equity-checkPriceButton'}
                            show={true}
                            disabled={products.every(product => Number(product.quantity) === 0)}
                            variant={products.length > 0 && products.some(product => Number(product.quantity) > 0) ? ButtonStyles.primary : ButtonStyles.disabled}
                            width={'115px'}
                            mobileWidth={'115px'}
                            mobileHeight={'27px'}
                            height={'38px'}
                            clicked={() => {
                                getPriceForItems();
                                setIsCheckPrice(true);
                                setIsCheckPriceClicked(true);
                            }}
                            fontSize={'14px'}
                        >
                            <div>
                                {translation(
                                    'equity.quickOrder.header.checkprice'
                                )}
                            </div>
                        </Button>
                    </HeadingBulk>
                </div>
            ) : (
                <Heading
                    cursor={'pointer'}
                    changeColor
                    id = 'quick-order-bulk-add-text'
                    onClick={() => setShowBulkAdd(true)}
                >
                    {bulkAddLabel ||
                        t('scheduleSurgery.quickOrder.bulkAddText')}
                </Heading>
            )}

            <Container id={isEquity && 'equityLogout'}>
                {/* check for other flows */}
                <AutoComplete
                    id = 'quick-order-search'
                    isEquity={isEquity}
                    disableCloseOnSelect
                    isSearchDropdown={true}
                    isBulkAddSearch={true}
                    isProductSearch={true}
                    inputRef={quickOrderRef}
                    showScrollBar={true}
                    forcePopupIcon={false}
                    disableClearable={false}
                    className="autocomplete"
                    value={selectedProduct}
                    inputValue={selectedProduct} 
                    options={productsList}
                    onOpen={handleOnOpen}
                    open={selectedProduct && open}
                    onClose={(e, reason) => {
                        if (reason !== 'select-option') {
                            // Returns true when the bundle popup is open (blur caused by user
                            // clicking inside the popup). In that case also skip setOpen(false).
                            const suppress = autoCompleteInputChange && autoCompleteInputChange(null, '', 'clear');
                            if (!suppress) {
                                onClose(e, reason);
                            }
                        }
                    }}
                    loading={loading}
                    searchIconHeight={'19px'}
                    searchIconWidth={'19px'}
                    style={AutocompleteStyles}
                    itemTemplate={(option) => {
                            return (
                            <SearchDropdown
                                data={option} 
                                padding={'10px'} 
                                productSearchDropdown={true} 
                                cartProducts={cartProducts}
                                onClose={() => {
                                    autoCompleteInputChange && autoCompleteInputChange(null, '', 'clear');
                                    onClose(null, '');
                                }}
                            />
                        );}
                    }
                    onChange={(value,reason)=>{
                        if(reason==='clear'){
                            setQuickOrderSearch('');
                        }
                        if(value){
                            updateSelectedProduct(value,reason);
                        }
                    }}
                    onInputChange={(e, value, reason) =>{
                        
                            autoCompleteInputChange(e, value, reason);
                    }
                    }
                    placeholder={
                        isEquity
                            ? translation(
                                  'equity.quickOrder.header.autoComplete.placeholder'
                              )
                            : t(
                                  'scheduleSurgery.quickOrder.enterOrSearchProduct'
                              )
                    }
                    field="cfn"
                    filterField="cfn"
                    optionValue="cfn"
                    showSearchIcon
                    autoCompleteInputFieldStyle={AutoCompleteInputFieldStyle}
                    loadingText={t('common.loadingText')}
                    noOptionsText={
                        !loading && productsList?.length === 0
                            ? t(
                                  'calendar.filterResultsPanel.noOptionText'
                              )
                            : loading && t('common.loadingText')
                    }
                    fontSizePlaceholder={isEquity ? '14px' : undefined}
                    paddingLeft={'15px'}
                    mbPaddingLeft={'0px'}
                    fontSize="14px"
                    border={'1px solid #EBEDED'}
                    optionPadding={'14px 16px'}
                    SearchGrayInactive={SearchGrayInactive}
                    hoverBgColor={'none'} 
                    onKeyPress={handlekeyPress}
                    zIndex="1"
                    isQuickOrder={true}
                />
            </Container>
        </QuickOrderHeaderContainer>
    );
};

export default QuickOrderHeader;
